import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { RightsService } from './services/rights.service';

@Directive({ selector: '[apply-access-rights]' })
export class ApplyAccessRightsDirective implements OnInit {

  @Input('apply-access-rights') right: any;

  constructor(
    private rightService: RightsService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) {
  }

  ngOnInit() {
    const isArray = Array.isArray(this.right);

    if (isArray) {
      const hasntAccessRight = this.right.some(specificRight => !this.rightService.hasAccessRights(specificRight));
      if (hasntAccessRight) {
        this.viewContainer.clear();
        return;
      }
    } else if (this.right !== undefined && !this.rightService.hasAccessRights(this.right)) {
      this.viewContainer.clear();
      return;
    }
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
